import { Production } from "./Production";
export class SiteList {
  siteId: string;
  siteName: string;
  plantBusiness: string;
  ownerSub: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
  countryName: string;
  owner: string;
  activityProcessFeedstockIndustry: string;
  status: string;
  onstreamYear: number;
  primaryProduct: string;
  capacity: number;
  capacityUOM: string;
  latitude: number;
  longitude: number;
  productionFacilityId : number;
  liquifierType : string;
  hostCustomer : string;
  activeFlag : string;
  facilityType : string;
  insertedBy: string;
  insertedDate: string;
  modifiedBy: string;
  modifiedDate: string;
}

export class Site {
  siteId: number;
  plantBusiness: string;
  localCompanyName: string;
  city: string;
  statProvId: number;
  siteName: string;
  address: string;
  countryId: string;
  latitude: number
  longitude: number;
  altitudeFeet : number;
  localCompanyType: string;
  industrialZoneId: number;
  franchiseId: number;
  paddname: string;
  comment: string;
  zipCode: string;
  lbuid: string;
  addressLocalLanguage: string;
  subRegion : string;
  localCompanyNameLocalLanguage: string;
  insertedBy: string;
  insertedDate: string;
  modifiedBy: string;
  modifiedDate: string;
  franchise: string;
  industrialZone: string;
  localCompanyTypeNavigation: string;
  paddnameNavigation: string;
  statProv: StateProv;
  production: Production[];
  companySites: [];
  productionFacilities: [];
  supplyDemandConnections: [];
  equipmentAndTechnologies: [];
  country: string;
  activeFlag: string;
  geoLocation:  string;
}

export class StateProv {
  countryId: string;
  province: string;
}